export class Noticias {
  id: string;
  titulo: string;
  subtitulo: string;
  resumen: string;
  imagenes: string[];
  videos: string[];
  tags: string[];
  fecha: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
